import {
  RouterProvider,
  createBrowserRouter,
} from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import MfaSignin from "./components/page-signin/MfaSignin";
import VerifyEmailPage from "./components/pages/applicant/signup/verify-email/VerifyEmailPage";
import OverViewPage from "./components/pages/student-dashboard/OverviewPage";
import ApplicationPage from "./features/application/ApplicationPage";
import SupportPage from "./components/pages/student-dashboard/SupportPage";
import ProfilePage from "./components/pages/student-dashboard/ProfilePage";
import HomePage from "./pages/HomePage";
import NotFoundPage from "./pages/NotFoundPage";
import CheckEligibility from "./features/check-eligibility/CheckEligibility";
import AuthLayout from "./layouts/AuthLayout";
import LoginForm from "./features/auth/LoginForm";
import ForgotPasswordForm from "./features/auth/ForgotPasswordForm";
import ResetPasswordForm from "./features/auth/ResetPasswordForm";
import SignupForm from "./features/auth/SignupForm";
import ContentLayout from "./layouts/ContentLayout";
import ViewApplicationPage from "./features/application/ViewApplicationPage";
import NewApplicationPage from "./features/application/new-application/NewApplicationPage";
import NewApplicationPageOld from "./features/application/new-application/NewApplicationPageOld";

function App() {
  const queryClient = new QueryClient();

  const router = createBrowserRouter([
    {
      path: "/",
      element: <HomePage />
    },
    {
      path: '/check-eligibility',
      element: <CheckEligibility />
    },
    {
      path: "/auth",
      element: <AuthLayout />,
      children: [
        {
          path: "signin",
          element: <LoginForm />,
        },
        {
          path: "forgot-password",
          element: <ForgotPasswordForm />,
        },
        {
          path: "reset-password/:token",
          element: <ResetPasswordForm />,
        },
        {
          path:'signup',
          element: <SignupForm />
        },
        {
          path: "mfa/:token",
          element: <MfaSignin />,
        },
      ],
    },
    {
      path: "/auth/verify-email/:token",
      element: <VerifyEmailPage />,
    },
    {
      path:"/",
      element: <ContentLayout />,
      children: [
        {
          path:'dashboard',
          element: <OverViewPage />
        },
        {
          path: "application",
          element: <ApplicationPage />,
        },
        {
          path: "application/new-application",
          element: <NewApplicationPage />,
        },
        {
          path: "/application/view-application/:id",
          element: <ViewApplicationPage />,
        },
      ]
    },
    {
      path: "/support",
      element: <SupportPage />,
    },
    {
      path: "/profile",
      element: <ProfilePage />,
    },
    {
      path: "*",
      element: <NotFoundPage />,
    },
  ]);
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router}></RouterProvider>
    </QueryClientProvider>
  );
}

export default App;
